const locationPaths = {
  LOCATION: "",
  SEARCH_LOCATION: "search",
  LOCATION_ID: (locationId) => locationId,
  LOCATION_PRODUCT_ID: (id) => `${id}/product`,
  LOCATION_INVENTORY_VALUE: (locationId) => `${locationId}/location-inventory-value`,
  LOCATION_STOCKTAKE: "stocktake",
};

export default locationPaths;
